<template>
  <div>
    <div class="hero">
      <h2 class="hero__title center-header mx-auto text-center">
        Testimonials
      </h2>

      <div class="hero__container">
        <div class="hero__indicator">
          <span
            class="hero__indicator-btn"
            :class="{'hero__indicator-active': activeSlide === 0}"
            @click="moveSlide(0)"
          ></span>
          <span
            class="hero__indicator-btn"
            :class="{'hero__indicator-active': activeSlide === 1}"
            @click="moveSlide(1)"
          ></span>
          <span
            class="hero__indicator-btn"
            :class="{'hero__indicator-active': activeSlide === 2}"
            @click="moveSlide(2)"
          ></span>
        </div>
        <div class="hero__testimonial">
          <div class="hero__slide-row" :style="{ transform: `translateX(-${activeSlide * 850}px)` }">
            <div class="hero__slide-col">
              <div class="hero__user-text">
                <p class="hero__user-text-p" align="justify">
                  <strong class="blue">BRILLIANT</strong> work by inte-QT. <br />
                  <br />
                  It was seamlessly managed by inte-QT, right from Quotation to timely delivery well within event schedule. Overall it's delighted experience.
                </p>
                <h5 class="hero__user-text-h">
                  Associate Director, Media Services <br />
                  World’s Leading Tier-1 Carrier <br />
                  London, UK
                </h5>
                <p class="hero__user-text-p">
                  World Championship Motor Racing
                </p>
                <div class="text-end">
                  <DinamicLink url="/testimonials" name="Read more" />
                </div>
              </div>
              <div class="hero__user">
                <img
                  src="/images/6Q7TYsB.jpg"
                  alt="1"
                  class="hero__user-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DinamicLink from '@/components/DinamicLink.vue';

export default {
  name: 'TestimonialCarousel',
  components: {
    DinamicLink
  },
  data() {
    return {
      activeSlide: 0, 
    };
  },
  methods: {
    
    moveSlide(slideIndex) {
      this.activeSlide = slideIndex;
    }
  }
}
</script>

<style scoped>
@import '@/assets/css/Variables.css';


.hero {
  color: #000000;
  width: 100%;
  position: relative;
}

@media (max-width: 992px) {
  .hero {
    height: 80vh;
  }
}

@media (max-width: 768px) {
  .hero {
    height: 1000px;
  }
}

@media (max-width: 576px) {
  .hero {
    height: 160vh;
  }
}

.hero__container {
  width: 47vw;
  height: 50vh;
  position: absolute;
  top: 20vh;
  left: 27vw;
  transform: translateY(-50%, -50%);
}

@media (max-width: 992px) {
  .hero__container {
    width: 90vw;
    left: 5vw;
    height: 60vh;
  }
}

.hero__indicator {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -50px;
  display: none;
}

.hero__indicator-btn {
  display: inline-block;
  height: 15px;
  width: 15px;
  margin: 4px;
  border-radius: 15px;
  background: hsla(205, 95%, 45%, 0.4);
  cursor: pointer;
  transition: 0.5s;
}

.hero__indicator-active {
  width: 45px;
}

.hero__title {
  margin-top: 8rem;
  margin-bottom: 85vh;
}

.hero__slide-row {
  display: flex;
  width: 60vw;
  transition: 0.45s;
  background: white;
}

@media (max-width: 1200px) {
  .hero__slide-row {
    width: 70vw;
  }
}

@media (max-width: 992px) {
  .hero__slide-row {
    width: 90vw;
  }
}

.hero__slide-col {
  width: 70vw;
  height: 50vh;
  position: relative;
}

@media (max-width: 1200px) {
  .hero__slide-col {
    width: 100vh;
  }
}

@media (max-width: 992px) {
  .hero__slide-col {
    width: 115vh;
  }
}

@media (max-width: 768px) {
  .hero__slide-col {
    width: 100vh;
  }
}

.hero__testimonial {
  width: 850px;
  height: 70vh;
}

@media (max-width: 1200px) {
  .hero__testimonial {
    height: 60vh;
    width: 10vh;
  }
}

.hero__user {
  position: absolute;
  top: 0;
  right: 25vw;
}

@media (max-width: 1400px) {
  .hero__user {
    right: 13vw;
  }
}

@media (max-width: 1200px),
@media (max-width: 992px) {
  .hero__user {
    right: 0;
  }
}

@media (max-width: 768px) {
  .hero__user {
    right: 25vw;
  }
}

@media (max-width: 576px) {
  .hero__user {
    right: 0vw;
  }
}

.hero__user-img {
  height: 500px;
  width: 400px;
  border-radius: 20px;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 576px) {
  .hero__user-img {
    width: 90vw;
  }
}

.hero__user-text {
  background-color: hsla(205, 95%, 95%, 0.7);
  width: 520px;
  height: 390px;
  position: absolute;
  left: -97px;
  top: 39%;
  transform: translateY(-50%);
  border-radius: 20px;
  color: #5bb2ff;
  padding: 45px;
  box-sizing: border-box;
  z-index: 2;
}

@media (max-width: 768px) {
  .hero__user-text {
    top: 52vh;
    left: 10vw;
    line-height: 1.3;
    width: 70vw;
    height: 380px;
  }
}

@media (max-width: 576px) {
  .hero__user-text {
    padding: 1rem;
    width: 90vw;
    height: 470px;
    top: 110vh;
    left: 0;
  }
}

.hero__user-text-p {
  color: #000000;
  font-size: 1rem;
  line-height: 24px;
}

.hero__user-text-h {
  margin: 35px 0 5px;
  color: #007bff;
}
</style>
